import React from "react";
import { Box } from "@mui/material";
import BeaconSearchText from "../../components/BeaconSearchText";
import { BeaconFilterButton } from "../../components/BeaconFilterButton";

const MapViewActions: React.FC = () => {

  return (
    <Box sx={{ display: "flex", alignItems: "end" }}>
      <BeaconSearchText />
    </Box>
  );
};

export default MapViewActions;
